import dateHelper from './dateHelper';

export default function updateUrl(object) {
  const dateFormat = 'MM-DD-YY HH:mm:ss';
  const {
    minCycleTime,
    maxCycleTime,
    cyclesFromParams,
    task,
    tasks,
    tags,
    virtualTask,
    device,
    devices,
    datetime_start,
    datetime_end,
    start_time,
    end_time,
    missed_steps,
    c_start_date,
    c_end_date,
    c_devices,
    interventions,
    model_version,
    runId,
    meta_key,
    meta_value,
    meta_comparison_operator,
    exclude_timeout_cycles,
    cycle_type,
  } = object;

  let query = {};
  if (runId && !datetime_start) {
    query['runId'] = runId;
    query['taskId'] = task;
    return this.$router.replace({
      name: this.$route.name,
      query,
    });
  }

  // Check if this is Station Analytics (single device + multiple tasks)
  // vs Operation Analytics (multiple devices + single task)
  const isStationAnalytics = device !== undefined && tasks !== undefined;

  if (isStationAnalytics) {
    // Station Analytics URL structure
    query = {
      device: device,
      tasks: tasks,
      datetime_start: dateHelper.formatDate(datetime_start, dateFormat),
      datetime_end: dateHelper.formatDate(datetime_end, dateFormat),
    };

    if (cycle_type) query['cycle_type'] = cycle_type;
    if (meta_key) query['meta_key'] = meta_key;
    if (meta_value) query['meta_value'] = meta_value;
    if (meta_comparison_operator)
      query['meta_comparison_operator'] = meta_comparison_operator;
  } else {
    // Operation Analytics URL structure
    query = {
      taskId: task,
      deviceId: devices,
      startTime: dateHelper.formatDate(datetime_start, dateFormat),
      endTime: dateHelper.formatDate(datetime_end, dateFormat),
    };
  }

  if (tags) query['tags'] = tags;
  if (minCycleTime) query['minCycleTime'] = minCycleTime;
  if (maxCycleTime) query['maxCycleTime'] = maxCycleTime;
  if (start_time) query['start_time'] = start_time;
  if (end_time) query['end_time'] = end_time;
  if (cyclesFromParams) query['cycles'] = JSON.stringify(cyclesFromParams);
  if (missed_steps) query['missed_steps'] = missed_steps;
  if (interventions) query['interventions'] = interventions;
  if (model_version) query['modelVersion'] = model_version;
  if (virtualTask) query['vt'] = virtualTask;
  if (c_start_date)
    query['c_start_date'] = dateHelper.formatDate(c_start_date, dateFormat);
  if (c_end_date)
    query['c_end_date'] = dateHelper.formatDate(c_end_date, dateFormat);
  if (c_devices) query['c_devices'] = c_devices;
  if (meta_key) query['meta_key'] = meta_key;
  if (meta_value) query['meta_value'] = meta_value;
  if (meta_comparison_operator)
    query['meta_comparison_operator'] = meta_comparison_operator;
  if (exclude_timeout_cycles !== undefined)
    query['exclude_timeout_cycles'] = exclude_timeout_cycles;
  if (cycle_type) query['cycle_type'] = cycle_type;

  this.$router.replace({
    name: this.$route.name,
    query,
  });
}
